import { render, staticRenderFns } from "./NewOrderRow.vue?vue&type=template&id=785ab25e"
import script from "./NewOrderRow.vue?vue&type=script&lang=js"
export * from "./NewOrderRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports